import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/img/logo.png';
import avatar from '../assets/img/user_avatar.jpeg';
import clsx from 'clsx';

const Header = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dropdownRef = useRef(null);

const navClasses = clsx(
  'items-center space-x-6',
  mobileMenuOpen
    ? 'absolute top-full left-0 right-0 bg-white px-4 py-4 flex flex-col space-y-4 transition-all duration-300'
    : 'hidden md:flex',
  'md:flex md:flex-row md:static md:bg-transparent md:px-0 md:py-0'
);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="bg-white shadow">
      <div className="container mx-auto px-1 py-4 flex items-center justify-between relative">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <Link to={`/fleet`} className="text-blue-600 hover:underline cursor-pointer">
            <img src={logo} alt="Tensor Planet Logo" className="h-8 w-auto" />
          </Link>
          {/* Uncomment below if you wish to display the brand name */}
          {/* <span className="text-xl font-bold text-gray-800">TENSOR PLANET</span> */}
        </div>
        {/* Mobile Menu Toggle */}
        <div className="md:hidden">
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="text-gray-600 hover:text-gray-900 focus:outline-none"
          >
            {mobileMenuOpen ? (
              // X icon (Close)
              <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6 18L18 6M6 6l12 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            ) : (
              // Hamburger icon (Menu)
              <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4 6h16M4 12h16M4 18h16"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            )}
          </button>
        </div>
        {/* Navigation (always visible) */}
        <nav className={navClasses}>
          <a className="px-4 py-2 bg-blue-600 text-white hover:text-gray-900 nav_link_active nav_link_parent nav_link_text">
            <i className="ti ti-layout-dashboard"></i> Fleet Summary
          </a>
          <a href="#provide-health" className="hover:text-gray-900 nav_link_parent nav_link_text">
           <i className="ti ti-truck-delivery"></i>  Vehicle Health
          </a>
          <a href="#" className="hover:text-gray-900 nav_link_parent nav_link_text">
           <i className="ti ti-file-analytics"></i>  Work Orders
          </a>
        </nav>

        {/* User Profile */}
        <div className="relative flex items-center space-x-2 cursor-pointer" ref={dropdownRef}>
          <img src={avatar} alt="User Avatar" className="h-8 w-8 rounded-full" />
          <span className="head_username_text">Test Admin</span>
          <span
            className="text-gray-600"
            onClick={() => setDropdownOpen((prev) => !prev)}
          >
            &#9662;
          </span>

          {dropdownOpen && (
            <div className="absolute right-0 top-full mt-2 w-44 bg-white border border-gray-200 rounded shadow-lg z-10">
              <ul>
                <li>
                  <a
                    href="#logout"
                    className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  >
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;